<template>
    <div class="card" v-bind:class="[question.type]">
        <div class="card-header answered" :id="'header-'+step+'Question'+question.id" data-toggle="collapse"
             :data-target="'#collapseStep'+step+'Question'+question.id"
             v-bind:aria-expanded="question.openByDefault ? 'true' : 'false'"
             aria-controls="collapseOne"
             :class="{'answered' : showSpoiler!==false}"
        >
            <h5 class="mb-0">
                <button class="btn btn-link">
                    {{question.label}}
                </button>
                <div class="recap">
                    <span v-for="(answer, answerIndex) in question.answers">
                        <img v-if="answer" :src="answer.imageUrl" alt="Image">
                    </span>
                </div>
            </h5>
        </div>
        <div :id="'collapseStep'+step+'Question'+question.id" class="collapse"
             v-bind:class="{show : question.openByDefault}"
             :aria-labelledby="'collapseStep'+step+'Question'+question.id" data-parent="#main-form">
            <div v-if="question.extraHtml !== undefined && question.extraHtml.content_top !== null !== undefined && question.extraHtml.content_top !== null"
                 v-html="question.extraHtml.content_top"></div>

            <div class="card-body">
                <div v-for="(answer, answerKey) in question.answers" class="checkbox-choice selected">
                    <div class="image-placeholder" :data-tooltip="answer.alt" data-tooltip-position="top">
                        <img :class="['img-'+step+'-'+question.id+'-'+answerKey]"
                             :src="answer.imageUrl" alt=""></div>
                    <p>{{answer.label}}</p>
                    <button v-if="answer.Popup !== apiUrl && answer.Legende !== undefined"
                            @click.stop="fillAndOpenDefaultModal(answer)" type="button" class="open-modal btn-modal"
                            data-toggle="modal"
                            :data-target="'#modal'+step+'-'+question.id+'-'+answerKey">
                        {{answer.BtnLegende === undefined ? "+ d'infos" : answer.BtnLegende}}
                    </button>
                </div>
            </div>
            <div v-if="question.extraHtml !== undefined && question.extraHtml.content_bottom !== null !== undefined && question.extraHtml.content_bottom !== null"
                 v-html="question.extraHtml.content_bottom"></div>

        </div>
    </div>
</template>

<script>
    import common from './mixins/common'

    export default {
        name: "MultipleImageRadioChoiceSelected",

        props: {
            question: Object,
            questions: Object,
            step: [String, Number],
        },
        created() {

        },
        watch: {
            '$route'(to, from) {
                if (to.params.step == this.step) {
                    this.addToAnswers();
                }
            }
        },
        mixins: [common],

        data() {
            return {
                selected: [],
                showSpoiler: false
            };
        },

        computed: {
            steps() {
                return this.$store.state.steps;
            },

            apiUrl() {
                return this.$store.state.apiUrl;
            }

        },

        methods: {
            fillAndOpenDefaultModal(answer) {
                let modal = $('#basicModal');
                modal.find('h5').text(answer.label);
                modal.find('img').attr('src', answer.Popup);
                modal.find('.extra-popup').html(answer.Legende)
                modal.modal('show');

            },
            addToAnswers: function () {
                const questionIndex = this.question.id;
                const question = this.questions[questionIndex];


                const answers = {
                    stepIndex: this.step,
                    questionIndex: questionIndex,
                    answers: {},
                };


                Object.keys(question.answers).forEach((answerIndex) => {
                    const answer = question.answers[answerIndex];
                    answers.answers[answerIndex] = {
                        stepIndex: this.step,
                        questionIndex: questionIndex,
                        questionType: this.questions[questionIndex].type,
                        effectOnSvg: this.questions[questionIndex].effectOnSvg,
                        index: answerIndex,
                        value: answer.value,
                        variable: question.variable,
                        name: answer.label,
                        changes: answer.changes !== undefined ? answer.changes : null,
                    };
                    this.selected[answerIndex] = answer;
                });

                this.$store.dispatch('addMultipleAnswers', answers);
            },
            initialize() {

            }
        }
    }
</script>

<style scoped>
    button.btn-modal {
        background: none;
        font-size: 13px;
        line-height: 20px;
        padding-top: 4px;
        color: grey;
        margin-top: 6px
    }

    .recap span {
        height: 100%;
    }

    [data-tooltip] {
        position: relative;
    }

    /* Tooltip styling */
    [data-tooltip]:before {
        content: attr(data-tooltip);
        display: none;
        position: absolute;
        background: #000;
        color: #fff;
        padding: 4px 8px;
        font-size: 14px;
        line-height: 1.4;
        min-width: 250px;
        text-align: center;
        border-radius: 4px;
        width: 150%;

    }

    /* Dynamic horizontal centering */
    [data-tooltip-position="top"]:before {
        left: 50%;
        -ms-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    [data-tooltip-position="top"]:before {
        bottom: 100%;
        margin-bottom: 10px;
    }

    [data-tooltip]:after {
        content: '';
        display: none;
        position: absolute;
        width: 0;
        height: 0;
        border: solid transparent;
    }

    [data-tooltip-position="top"]:after {
        left: 50%;
        margin-left: -6px;
        margin-bottom: 4px;
    }

    [data-tooltip-position="top"]:after {
        bottom: 100%;
        border-width: 6px 6px 0;
        border-top-color: #000;
    }

    /* Show the tooltip when hovering */
    [data-tooltip]:hover:before,
    [data-tooltip]:hover:after {
        display: block;
        z-index: 100;
    }

    img {
        height: 100px;
    }

    img[class*="img-1-2-"] {
        width: 200px;
        height: auto;
    }

    .card-header img {
        height: 100%;
    }

    .checkbox-choice {
        flex-grow: 1;
        margin-bottom: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column nowrap;
    }

    .checkbox-choice p {
        margin: 10px 0 0 0;
        max-width: 85%;
    }

    .checkbox-choice.selected {
        font-weight: bold;
    }
</style>
